// extracted by mini-css-extract-plugin
module.exports = {"section":"TVRentalChooser_section__s4Fbu","panel":"TVRentalChooser_panel__WPz6M","links":"TVRentalChooser_links__5UTwM"};